import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {MasterService} from'../../masters/master.service';
import { LoaderService } from 'src/app/common/loader.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { AddProfessionComponent } from './add-profession/add-profession.component';


@Component({
  selector: 'app-profession',
  templateUrl: './profession.component.html',
  styleUrls: ['./profession.component.scss']
})
export class ProfessionComponent implements OnInit {

  searchCriteria={};
  shName='';
  rowData: any[];
  toggleColumn = true;
  addnewProfession;
  profClassList=[];
  profGroupList=[];
  profDivisionList=[];
  professionSearchForm : FormGroup;
  partnerTypes = [];

  newProfession:AddProfessionComponent;
  @ViewChild(AddProfessionComponent, { static: true }) set Content(newProfessionRef) {
    this.newProfession = newProfessionRef;
  }

  constructor(private formBuilder: FormBuilder,private router:Router,private route: ActivatedRoute,private masterService:MasterService,private loaderService: LoaderService,config: NgbModalConfig, private modalService: NgbModal) {
    this.route.queryParams.subscribe(param =>{
      this.rowData=[];
      this.shName=param.masterShName;
      this.getMasterForm();
      this.loadMasters();
    });
  }
loadMasters(){
  this.searchCriteria={};
  this.searchCriteria={
    masterShName:'DIVISION',
    master:{}
  }
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
    this.profDivisionList = response['result'];
  })
  this.searchCriteria={
    masterShName:'CLASS',
    master:{}
  }
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
    this.profClassList = response['result'];
  })
  this.searchCriteria={
    masterShName:'PROGROUP',
    master:{}
  }
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
    this.profGroupList = response['result'];
    this.masterSearch(this.shName);
  })
  if(this.shName=='ASSETTYPE'){
    this.masterService.getPartnerTypes().subscribe(response => {
      if (response && response['result']) {
        this.partnerTypes = response['result'];
      }
    })
  }
}
  ngOnInit() {
  }
  
  masterSearch(masterShName){
    this.rowData=[];
    this.searchCriteria={};
    this.BuildSearchCriteria(masterShName);
    this.loaderService.display(true);
    this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
     let result = response['result'];
     this.loaderService.display(false);
    this.rowData=result;
   })
  }
    onRowClicked(event){
    this.toggleColumn = false;
    this.addnewProfession=true;
    this.loadMasterById(event);
  
    }
    addNewprofession(){
      this.router.navigate(['addProfession']);
      this.router.navigate(['addProfession'],{queryParams: {masterShName: this.shName}});
    }
    hideRightDiv(){
      this.addnewProfession=false;
      this.toggleColumn = true;
    }
    exportExcel() {
    /*   import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(this.rowData);
          const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
          const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
          this.saveAsExcelFile(excelBuffer, "primengTable");
      }); */
  }
  loadMasterById(event){
    this.loaderService.display(true);
    this.fetchByIdIp(event)
    this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
      this.loaderService.display(false);
      if (response['code'] == 'S0000') {
        let result = response['result'][0];
        this.newProfession.patchFormValues(result);
      }
    });
  }
   onProfessionRowSelect(proession, editProfession) {
    this.modalService.open(editProfession, { size: 'lg', container: '.page-content' });
    this.newProfession.addProfessionForm =  JSON.parse(JSON.stringify(proession.data));
  }  
  get f() {
    return this.professionSearchForm.controls;
  }
  private getMasterForm() {
    this.professionSearchForm = this.formBuilder.group({
      'code': new FormControl(),
      'description': new FormControl(),
      'prclaId': new FormControl(),
      'prgrpId': new FormControl(),
      'prdivId': new FormControl(),
      'staRecCode': [true],
      'partnerType': new FormControl(),
      
   })
  }
 
  BuildSearchCriteria(shName){
        let masterIp={
          code:this.f.code.value,
          description:this.f.description.value,
          staRecCode:this.f.staRecCode.value ? 'A' :'I'
        }
        this.searchCriteria={
          masterShName:shName,
          master:masterIp
    }
  }
  fetchByIdIp(event){
    let searchIp={
      id:event.data.id
    }
    this.searchCriteria={
      masterShName:this.shName,
      master:searchIp
    }
}
  resetForm(){
    this.professionSearchForm.reset();
    this.rowData=[];
  }
}
